import styled from '@emotion/styled';
import { Container as RootContainer } from '../../styled';

export const Container = styled(RootContainer)`
  margin-top: 120px;
  color: ${(props) => props.theme.color.blue.default};
  background-color: ${(props) => props.theme.color.blue.light};
  padding-top: 96px;
  padding-bottom: 96px;
  max-width: none;
`;

export const ListWrapper = styled.div`
  margin-top: 40px;
`;
